import UIFormItem from './UIFormItem.vue';
import { createComponent } from '@vue/composition-api';

export default (options: Parameters<typeof createComponent>[0]) => createComponent({
  mixins: [{
    inheritAttrs: false,
    model: {
      event: 'update:value',
    },
    props: {
      ...UIFormItem.props,
    },
    components: {
      UIFormItem,
    },
  }],
  ...options,
});
